<div class="relative w-auto min-w-[92px]">
  @if (!hideTrigger) {
  <button class="w-full h-9 flex justify-between items-center px-4 py-2 rounded-md shadow-md transition-colors"
    [class.bg-gray-100]="!startDateTime()" [class.text-gray-800]="!startDateTime()" [class.bg-blue-100]="startDateTime()"
    [ngClass]="{'text-[#5598F6]': startDateTime()}" (click)="toggleDropdown()">
    <span class="text-sm">
      @if (startDateTime() && endDateTime()) {
      <span class="line-clamp-1">
        <span class="font-bold text-[#5598F6]">Fecha:</span>
        <span class="ml-1">{{ formatDate(startDateTime()) }} - {{ formatDate(endDateTime()) }}</span>
      </span>
      } @else if (startDateTime() && !endDateTime()) {
      <span class="line-clamp-1">
        <span class="font-bold text-[#5598F6]">Fecha:</span>
        <span class="ml-1">{{ formatDate(startDateTime()) }} (seleccione fin)</span>
      </span>
      } @else {
      <span class="text-gray-800 line-clamp-1">
        {{ placeholder }}
      </span>
      }
    </span>

    <div class="flex items-center justify-center w-5 h-5 flex-shrink-0 ml-2">
      @if (isOpen()) {
      <i class="fi fi-rr-angle-small-up text-[24px] flex items-center justify-center"></i>
      } @else {
      <i class="fi fi-rr-angle-small-down text-[24px] flex items-center justify-center"></i>
      }
    </div>
  </button>
  }

  @if (isOpen()) {
  <div class="bg-white rounded-lg shadow-[0_4px_8px_0_rgba(0,0,0,0.16)] p-4 w-[calc(100vw-2rem)] max-w-[550px] md:w-auto md:min-w-[550px]" 
       (click)="$event.stopPropagation()">
    <div class="space-y-3">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <!-- Seleccionar fecha -->
        <div>
          <div class="mb-3">
            <h4 class="text-xs font-medium text-[#728197] mb-3">Seleccionar fecha</h4>
            <div class="p-2 rounded border border-[#9AA8BC33]">
              <label class="block text-xs font-medium text-[#728197] mb-1">Fecha inicio</label>
              <input type="date"
                [(ngModel)]="startDateString"
                (ngModelChange)="onDateChange('start', $event)"
                class="w-full px-3 mb-4 py-2 border border-[#9AA8BC33] rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" />
              
              <label class="block text-xs font-medium text-[#728197] mb-1">Fecha fin</label>
              <input type="date"
                [(ngModel)]="endDateString"
                (ngModelChange)="onDateChange('end', $event)"
                class="w-full px-3 py-2 border border-[#9AA8BC33] rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
          </div>
        </div>

        <!-- Seleccionar hora -->
        <div>
          <div class="mb-3">
            <h4 class="text-xs font-medium text-[#728197] mb-3">Seleccionar hora</h4>
            <div class="p-2 rounded border border-[#9AA8BC33]">
              <label class="block text-xs font-medium text-[#728197] mb-1">Hora inicio</label>
              <input type="time"
                [(ngModel)]="startTimeString"
                (ngModelChange)="onTimeChange('start', $event)"
                class="w-full px-3 mb-4 py-2 border border-[#9AA8BC33] rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" />
              
              <label class="block text-xs font-medium text-[#728197] mb-1">Hora fin</label>
              <input type="time"
                [(ngModel)]="endTimeString"
                (ngModelChange)="onTimeChange('end', $event)"
                class="w-full px-3 py-2 border border-[#9AA8BC33] rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" />
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="flex justify-end pt-2">
        <button type="button" (click)="clearSelection()"
          class="px-5 py-2 mr-3 text-[16px] text-gray-600 hover:text-gray-800">
          limpiar
        </button>
        <button type="button" (click)="applyFilter()"
          class="px-5 py-2 bg-[#4FD1C5] text-white rounded-2xl text-[16px]">
          Aplicar
        </button>
      </div>
    </div>
  </div>
  }
</div>
